import React ,{ useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { postData, getList } from "../../../services/baseServices"
import { toast } from 'react-toastify';
import { getObjectToFormData } from '../../../helper/utils'
import _ from 'lodash'
import { DEBOUNCE_TIME } from "../../../helper/env"

    const FILE_SIZE = 1024*1024;
    const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg','image/png']
    const schema = yup.object().shape({
        credit_bank_account_id: yup.string().required('Bank is required field'),
        chalan_no: yup.string().required('Chalan no is required'),
        image_file: yup.mixed()
            .test("Required", "Chalan image is a required field", (value) => {
                return !value || value.length > 0;
            })
            .test('FileSize', 'Uploaded file is to big, image size not more than 1mb.', (value) =>{
                return  value === null || (value && value[0]?.size <=FILE_SIZE) 
            })
            .test('type', 'Invalid image format, supported image format are .jpg, .jpeg and .png',(value) =>{
                return value === null || (value && SUPPORTED_FORMATS.includes(value[0]?.type))
            })
    });

const DepositModal = ({show, handleClose, amount, query_params}) => {
    const [bankList, setBankList] = useState([])
    const [submitting, setSubmitting] = useState(false)
    const { register, handleSubmit, formState:{ errors } } = useForm({
        resolver: yupResolver(schema)
    });

    useEffect(()=> {
        getList("bank_accounts")
        .then(res => {
            setBankList(res)
        })
        .catch(errMsg => {
        })
    }, [])

    const debouncedOnSubmit = _.debounce((values)=>{
        onSubmit(values)
    }, DEBOUNCE_TIME);
  
    const handleWithDebounceSubmit = (values) => {
        const challanNo = values.chalan_no.split(',');
        const img_file = values.image_file;
  
    if( challanNo.length === img_file.length){
        setSubmitting(true)
        debouncedOnSubmit(values);
    }else{
        toast.error('Total Challan no and Challan Image must be same')
    }

    }
  

    const onSubmit = data =>{
        const img_files = [...data.image_file]
        const {start_date_time, end_date_time} = query_params;
        let params = {
            credit_bank_account_id: data.credit_bank_account_id,
            amount: Math.ceil(amount),
            chalan_no: data.chalan_no,
            images_file: img_files,
            start_date_time,
            end_date_time
        }

        const paramsData = getObjectToFormData(params)
        postData("bank_transactions", paramsData)
        .then((res)=>{
            if(res.success) {
                toast.success(res.message);
                handleClose(true)
            } else {
                toast.error(res.message)
            }
            setSubmitting(false)
        })
        .catch(exp =>{
            toast.error(exp)
            setSubmitting(false)
        })
    }
    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Deposit Info
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit = {handleSubmit(handleWithDebounceSubmit)}>
                    <Modal.Body className="p-5">
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>Amount</p>
                            </div>
                            <div className="col-sm-7">
                                <p>{amount}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                <p>Bank <span className="text-danger">*</span></p>
                            </div>
                            <div className="col-sm-7">
                                <select 
                                    name="bank_name" 
                                    className='form-control' 
                                    {...register('credit_bank_account_id')}
                                >
                                    <option value="">--Select Bank--</option>
                                    {
                                        bankList?.map((bank, index) =>{
                                            return(
                                                <option value={`${bank.id}`} key={index}>{bank.title}</option>)
                                        }
                                        )
                                    }
                                </select>
                                <p className='text-danger' >{errors.credit_bank_account_id?.message}</p>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-sm-5">
                                Chalan No <span className="text-danger">*</span>
                            </div>
                            <div className="col-sm-7">
                                <input type="text"
                                        className={'form-control'}
                                        {...register('chalan_no')}
                                        name="chalan_no" placeholder="Enter Chalan No, Ex: 1001,1002, 1003,..."/>
                                <p className='text-danger' style={{lineHeight:'20px'}}>{errors.chalan_no?.message}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-5">
                                    Chalan Images <span className="text-danger">*</span>
                            </div>
                            <div className="col-sm-7">
                                <input 
                                    multiple
                                    type="file" 
                                    className="form-control-file" 
                                    {...register('image_file')}
                                />
                                <p className='text-danger' style={{lineHeight:'20px'}}>{errors.image_file?.message}</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit' disabled={submitting}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default DepositModal
